import Vue from "vue";
import App from "./App";
import router from "./config/routes";
import 'src/plugins'
import './assets/js/app'
import i18n from './lang'
import './permission' // 本地开发引入此文件可以刷新当前页面

import store from "./store";
// NProgress
import NProgress from "nprogress";
import "nprogress/nprogress.css";

// import "../static/css/colorUi.css";
import "../static/plugins/colorUI/color.css";
import "src/plugins/vee-validate";
import babelpolyfill from 'babel-polyfill';
Vue.use(babelpolyfill);
// Vuex
import Vuex from "vuex";
// Axios
import axios from "./api/api.config.js"
Vue.prototype.$http = axios;
// 全局工具类
import globalTools from "./config/globalTools.js"
Vue.prototype.$globalTools = globalTools;

import * as  baseConfig from './config/config.js'
Vue.prototype.$baseConfig = baseConfig;

NProgress.configure({ showSpinner: false });

//echarts
import echarts from 'echarts';
Vue.prototype.$echarts = echarts;

// Clipboard
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

// Lodash
import lodash from 'lodash';
Vue.use(lodash);

const moment = require('moment')
Vue.prototype.$moment = moment;//赋值使用
Vue.prototype.$locale = i18n.locale;  //current locate
Vue.prototype.$s = (key, params) => {
  console.log(`~ key`, key)
  return i18n.t(key, params)
}
Vue.use(require('vue-moment'), {
  moment
})

import Mixin from './mixin.js';
import 'src/minxins/useMessage'

// Filters
Vue.filter('formatDatetimeWithPattern', function (value, pattern) {
  return value == null ? '' : moment(value).format(pattern)
});
Vue.filter("capitalizeCharacter", function (str) {
  const arr = str.split(" ");
  for (var i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }
  return arr.join(" ");
});
// AdminLTE
require('./assets/less/AdminLTE.less')
require('./assets/less/skins/skin-blue.less')
require('./assets/css/tms.css')
require('./assets/css/dialog.css')
require("./assets/css/element-ui/element-variables.scss");
require('./assets/css/main.css')
require('./assets/css/element-ui/main.scss')
require('./assets/css/icon.css')
require('./assets/css/mainicon.css')
// Toastr
require('toastr/build/toastr.min.css')

//editor
// require('../static/plugins/xheditor/xheditor-1.2.2.min.js');
// require('../static/plugins/xheditor/xheditor_lang/zh-cn.js');
Vue.use(Vuex);

var vueApp = new Vue({
  el: '#app',
  mixins: [Mixin],
  router,
  i18n,
  store,
  render: h => h(App),
  data: {
    eventHub: new Vue()
  }
})

// Security check
router.beforeEach((to, from, next) => {
  // 百度埋点
  if (_hmt) {
    if (to.path) {
      // eslint-disable-next-line
      _hmt.push(['_trackPageview', '/#' + to.path])
    }
  }
  NProgress.start();
  window.scroll(0, 0);
  next()
  NProgress.done();
  /*
   if (!auth.user.authenticated && to.path !== '/login') {
   next('/login');
   } else {
   if (auth.user.authenticated && to.path === '/login') {
   next({ path: '/dashboard' });
   } else {
   next();
   }
   }
   */
})
export default vueApp 



// WEBPACK FOOTER //
// ./src/main.js